import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, useDisclosure } from "@heroui/react";
import { AlertCircle } from "assets/icons";
import ButtonNew from "components/buttonNew/buttonNew";

export interface ConfirmationModalProps {
    title: string;
    description: string;
    isOpen: boolean;
    confirmationAction: () => void;
    confirmationIcon: any;
    confirmationText: string;
    declineText: string;
    onClose: () => void;
}

const ConfirmationModal = ({ isOpen, onClose, title, description, confirmationAction, confirmationIcon, confirmationText, declineText }: ConfirmationModalProps) => {
    const { onOpenChange } = useDisclosure();

    return (
        <Modal
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            onClose={onClose}
            isDismissable={true}
            isKeyboardDismissDisabled={true}
            className="font-normal text-neutral-primary"
        >
            <ModalContent>
                {(onClose) => (
                    <>
                        <ModalHeader className="flex flex-col gap-1">
                            <p className="flex items-center gap-1 text-sm font-medium text-status-bad">
                                <AlertCircle className="h-[17px] w-[17px]" /> {title}
                            </p>
                        </ModalHeader>
                        <ModalBody>
                            <p>
                                {description}
                            </p>
                        </ModalBody>
                        <ModalFooter className="justify-start">
                            <ButtonNew
                                variant="primaryStatusRed"
                                onClick={confirmationAction}
                                icon={confirmationIcon}
                                label={confirmationText}
                            />
                            <ButtonNew
                                variant="secondaryNeutral"
                                onClick={onClose}
                                label={declineText}
                            />
                        </ModalFooter>
                    </>
                )}
            </ModalContent>
        </Modal>
    );
};

export default ConfirmationModal;
